import { render, staticRenderFns } from "./aFeeDetailImport.vue?vue&type=template&id=15853324&scoped=true"
import script from "./aFeeDetailImport.vue?vue&type=script&lang=js"
export * from "./aFeeDetailImport.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailImport.vue?vue&type=style&index=0&id=15853324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15853324",
  null
  
)

export default component.exports